import React, { createContext, ReactNode } from 'react';

import { FeaturesSortingOption, TasksSortingOption } from './models';
import { useSessionStorageState } from './hooks';

export interface AppContextType {
  features: string[];
  setFeatures: React.Dispatch<React.SetStateAction<string[]>>;
  filterFeatures: string[];
  setFilterFeatures: React.Dispatch<React.SetStateAction<string[]>>;
  sortFeaturesBy: FeaturesSortingOption;
  setSortFeaturesBy: React.Dispatch<React.SetStateAction<FeaturesSortingOption>>;
  sortTasksBy: TasksSortingOption;
  setSortTasksBy: React.Dispatch<React.SetStateAction<TasksSortingOption>>;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const [features, setFeatures] = useSessionStorageState<string[]>('features', []);
  const [filterFeatures, setFilterFeatures] = useSessionStorageState<string[]>('filterFeatures', []);
  const [sortFeaturesBy, setSortFeaturesBy] = useSessionStorageState<FeaturesSortingOption>('sortFeaturesBy', 'id');
  const [sortTasksBy, setSortTasksBy] = useSessionStorageState<TasksSortingOption>('sortTasksBy', 'task-id');

  return (
    <AppContext.Provider
      value={{
        filterFeatures,
        setFilterFeatures,
        features,
        setFeatures,
        sortFeaturesBy,
        setSortFeaturesBy,
        sortTasksBy,
        setSortTasksBy,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
